module.exports = __webpack_public_path__ + "img/checkSquare.255db56b.svg";